import React, { Component, Fragment } from "react"
import PropTypes from "prop-types"
import { observer } from "mobx-react"
import { Table } from "semantic-ui-react"
import _ from "lodash"
import ProductRowDefault from "components/Product/ProductRowDefault"
import shop  from "shop/shop"
import Responsive                                                from "react-responsive"

@observer
export default class ProductTable extends Component {
  static propTypes = {
    list    : PropTypes.object,
    cart    : PropTypes.object,
    onChange: PropTypes.func,
    products: PropTypes.array,
  }
  
  render() {
    let { list, cart, products, onChange } = this.props
    let ProductRow = this.props.row || ProductRowDefault
    let positions = list || products
    if ( list ) positions = list.products
    let rows = _.map( positions, ( product, index ) => {
      return (
        <ProductRow key={index} index={index} onChange={onChange} list={list} cart={cart} product={product}/>
      )
    } )
    return (
      <Fragment>
      <Responsive maxWidth={789}>
        <table className="mobileRespTable" >
          <colgroup>
            <col width="10%"/>
            <col width="90%"/>
            </colgroup>
          <tbody>
          {rows}
          </tbody>
        </table>
      </Responsive>
      <Responsive minWidth={790}>
      <Table>
        <colgroup>
          <col width=""/>
          <col width=""/>
          <col width=""/>
          <col width="20%"/>
          <col width="10%"/>
          {shop.session && shop.session.shopuser && !shop.session.shopuser.guest &&<col width="10%"/>}
          <col width="10%"/>
          {shop.session && shop.session.shopuser && !shop.session.shopuser.guest &&<col width="10%"/>}
        </colgroup>
        <thead>
        <tr>
          <th>&nbsp;</th>
          <th>&nbsp;</th>
          <th>{translate( "article" )}</th>
          {/*<th>&nbsp;</th>*/}
          <th>{translate( "deliverable" )}</th>
          {/*<th>Preis/Stück</th>*/}
          {/*<th>{translate( "deliverable" )}</th>*/}
          {/*<th>{translate("Preis/Stück")}</th>*/}
          {shop.session && shop.session.shopuser && !shop.session.shopuser.guest && <th>{translate( "Preis/VE" )}</th>}
          <th>{translate( "VE" )}</th>
          <th>{translate( "Menge" )}</th>
          {/*<th>{translate( "total count" )}</th>*/}
          {shop.session && shop.session.shopuser && !shop.session.shopuser.guest &&  <th>
            <div className="tr">
              {translate( "sum" )}
            </div>
          </th>}
          {/*<th>{translate( "VE" )}</th>*/}
          {/*<th style={{textAlign: "right"}}>{translate( "amount (VE)" )}</th>*/}
          {list && <th style={{ textAlign: "right" }}>{translate( "" )}</th>}
          <th>{translate( "Menge (VE)" )}</th>
        </tr>
        </thead>
        <tbody>
        {rows}
        </tbody>
      </Table>
      </Responsive>
    </Fragment>
    )
  }
}







// WEBPACK FOOTER //
// ./src/theme/hvz/components/Product/ProductTable.js